import { START_LOADING, STOP_LOADING } from './LoaderTypes'


export function StartLoading(pageName?: string, message?: string) {
    return {
        type: START_LOADING,
        payload: { isLoading: true, message: message || '', pageName: pageName || '' }
    }
}
export function StopLoading(pageName?: string, message?: string,) {
    return {
        type: STOP_LOADING,
        payload: { isLoading: false, message: message || '', pageName: pageName || '' }
    }
}